import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatchCart } from '../contextreducer/ContextReducer';


export default function Option({ ind }) {
  const dispatch = useDispatchCart();


  const handleDelete = () => {
    dispatch({ type: "REMOVE", index: ind });
    toast.success("Item deleted successfully.✅!", {
      position: "top-center",
      autoClose: 2000,
    });
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  return (
    <div className="add_remove_select">
      <p style={{ cursor: "pointer" }} onClick={handleDelete}>Delete</p>
      <span>|</span>
      <p className="forremovemedia">Save For Later</p>
      <span>|</span>
      <p className="forremovemedia">See More Like This</p>
      <ToastContainer />
    </div>
  );
}
